module.exports = __webpack_public_path__ + "static/willbud-puck-mobile-06d2fe7773bb46180b02c7b1dc1e26b9.jpg";